<div
  #item
  data-testid="schedule-item"
  [sbTooltip]="tooltipTemplate()"
  [sbTooltipPlacement]="'top'"
  [sbTooltipDisabled]="isDragging"
  [sbTooltipMaxWidth]="'30rem'"
  dnd-free-draggable
  [dragEnabled]="!isDisabled && !isLocked() && scheduleItem.permissions?.canEdit"
  [dragData]="draggable"
  class="schedule-item group/shift flex h-[34px] items-center rounded-lg border-2"
  [ngClass]="{
    'border-dashed border-default': isDisabled,
    'border-solid': !isDisabled,
    'sh-tl__conflicts': isConflicted,
    'schedule-item-ghost': shouldDisplayGhostWhenDraggingButNotCopying || !isDraggingGracePeriod,
    'cursor-default': isLocked(),
  }"
  [style.background-color]="isDisabled ? 'var(--colors-background-surface-page)' : (resolvedColor() | userColorBg)"
  [style.border-color]="resolvedColor()"
  [attr.tabindex]="hasActions() ? 0 : null"
  [attr.role]="hasActions() ? 'group' : null"
  [attr.aria-labelledby]="hasActions() ? contentId : null"
>
  <div class="relative top-0 left-0">
    <div
      class="absolute top-[-13px] ml-[2px] h-[26px] w-[6px] min-w-[6px] rounded-full"
      [style.background-color]="resolvedColor()"
    ></div>
  </div>
  <div class="sh-tl__static relative w-full">
    <div class="contents" [id]="contentId">
      <ng-content select="[schedule-item-content]"></ng-content>
    </div>

    @if (actionsActivated() && !isDragging && !scheduleItem.loading && hasActions()) {
      <sb-schedule-item-actions
        class="absolute inset-x-px top-1/2 -translate-y-1/2 transform opacity-0 transition-opacity group-hover/shift:opacity-100 focus-within:opacity-100"
        [canEdit]="!!scheduleItem.permissions?.canEdit"
        [canCreate]="!!scheduleItem.permissions?.canCreate"
        [canDelete]="!!scheduleItem.permissions?.canDelete"
        [canFindCover]="canFindCover()"
        (edit)="edit($event)"
        (view)="view($event)"
        (create)="create($event)"
        (delete)="delete($event)"
        (findCover)="findCover.emit($event)"
      />
    }
  </div>
</div>
